import { render, staticRenderFns } from "./registration-certificate.vue?vue&type=template&id=37ab5db2&scoped=true"
import script from "./registration-certificate.vue?vue&type=script&lang=js"
export * from "./registration-certificate.vue?vue&type=script&lang=js"
import style0 from "./registration-certificate.vue?vue&type=style&index=0&id=37ab5db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ab5db2",
  null
  
)

export default component.exports